export default {
  estaCarregando: false,
  media_frequencia: [],
  lista: [],
   filtros: {
      data_inicial: '',
      data_final: '',
  }
}
